import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    enableWatchlist: {
        type: 'boolean',
        title: 'Enable Watchlist',
        description: '',
    },
};

const dependencies: coreTypes.Schema = {
    enableWatchlist: {
        oneOf: [
            {
                properties: {
                    enableWatchlist: { enum: [true] },
                    watchlistStorageName: {
                        type: 'string',
                        description: 'Local storage item name',
                        title: 'Storage Name',
                        default: 'watchlist',
                    },
                    watchlistDataId: {
                        type: 'string',
                        title: 'Enter property Id',
                        description:
                            'This property will be used as id when adding items to watch list',
                    },
                    addToWatchlistText: {
                        type: 'string',
                        title: 'Add to watchlist text',
                    },
                    removeFromWatchlistText: {
                        type: 'string',
                        title: 'Remove from watchlist text',
                    },
                    watchlistButtonText: {
                        type: 'string',
                        title: 'Watchlist button name',
                    },
                    showAllFundsBtnText: {
                        type: 'string',
                        title: 'Show all funds button text',
                    },
                },
            },
            {
                properties: {
                    enableWatchlist: { enum: [false] },
                },
            },
        ],
    },
};

const uiSchema = {
    enableWatchlist: { 'ui:widget': 'CustomCheckbox' },
    watchlistStorageName: { 'ui:widget': 'CustomTextInput' },
    watchlistDataId: { 'ui:widget': 'CustomTextInput' },
    watchlistButtonText: { 'ui:widget': 'ResourcePicker' },
    showAllFundsBtnText: { 'ui:widget': 'ResourcePicker' },
    addToWatchlistText: { 'ui:widget': 'ResourcePicker' },
    removeFromWatchlistText: { 'ui:widget': 'ResourcePicker' },
};

const watchListSchema = {
    schema,
    uiSchema,
    dependencies,
};

export default watchListSchema;
